import { FunctionComponent } from "react";

import {
  FieldItem,
  IconSelect,
  FieldItemStyleProps,
  OptionsSelectProps,
  IStyleFunctionOrObject,
  FieldItemStyles,
  useFieldRegister,
  useFieldContext
} from "@bps/fluent-ui";

type FormUsersSelectProps = Omit<
  OptionsSelectProps,
  "selectedKeys" | "onChangeSelectedKeys" | "multiSelect"
> & {
  fieldItemStyles?: IStyleFunctionOrObject<
    FieldItemStyleProps,
    FieldItemStyles
  >;
  name: string;
};

export const FormIconSelect: FunctionComponent<FormUsersSelectProps> = ({
  name,
  fieldItemStyles,
  ...restUsersSelectProps
}) => {
  useFieldRegister(name);
  const { meta, value, setFieldValue } = useFieldContext<string>(name);

  return (
    <FieldItem name={name} errorMessage={meta?.error} styles={fieldItemStyles}>
      <IconSelect
        selectedKeys={value ?? ""}
        onChangeSelectedKeys={setFieldValue}
        {...restUsersSelectProps}
      />
    </FieldItem>
  );
};
